import { useModuleStatuses } from '@features/properties';
import { useMemo } from 'react';
import { ModuleType } from '../BasketListing.types';

export const useModulesToRecommend = ({ modules }: { modules: ModuleType[] }) => {
  const {
    statuses: { isRoomsEnabled },
  } = useModuleStatuses();

  const recommendedModules = useMemo(() => {
    let updatedModules = modules;

    if (isRoomsEnabled && !updatedModules.includes('rooms')) {
      updatedModules = updatedModules.concat('rooms');
    }

    // We don't ever want to show these types of modules
    return updatedModules.filter(
      (module) => module !== 'products' && module !== 'vouchers' && module !== 'events'
    );
  }, [modules, isRoomsEnabled]);

  return recommendedModules;
};
